import React from 'react'
import styled from 'styled-components'
import {useSelector} from 'react-redux'
import Icon from 'components/Icons'
import {urlPatterns} from 'utils/enums/icons'
import {fieldtype} from 'utils/enums/fieldtype'
import Date from 'components/Date'
import Image from 'components/Image'
import Toggle from 'components/Toggle'
import Textarea from 'components/Textarea'
import TextField from 'components/TextField'
import LinkedField from 'components/LinkedField'
import Phone from 'components/Phone'
import Number from 'components/Number'
import Formula from 'components/Formula'
import {injectIntl} from 'react-intl'

const Url = styled.a`
    margin-left: 10px;
    display: flex;
`

const Base = styled.span`
    margin: 0 10px;
    text-overflow: ellipsis;
    height: 100%;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    opacity: ${props => props.lookup ? '0.5' : '1'};
`

const CellValue = ({defaultValue, environment, row, name, min, max, foreignerEcn, linkedRelation, title,
    disableCreate, type, lookupType, lookupConfig, config, readonly, handleUpdateValue}) => {
    
    const permissions = useSelector((state) => state.login.permissions)

    const getField = (format, settings, uneditable, lookup) => {
        switch(format) {
            case fieldtype.number:
                return (
					<Number
						lookup={lookup}
						defaultValue={defaultValue}
						config={settings}
						readonly={uneditable}
						handleUpdate={handleUpdateValue}
						environment={environment}
                        row={row}
						name={name}
					/>
                )

            case fieldtype.datetime:
                return (
                    <Date
                        defaultValue={defaultValue}
                        config={settings}
                        readonly={uneditable}
                        handleUpdateValue={handleUpdateValue}
                        name={name}
                        lookup={lookup}
                        environment={environment}
                        row={row}
						min={min}
						max={max}
                    />
                )

            case fieldtype.image:
                return (
                    <Image
                        src={defaultValue}
                        readonly={uneditable}
                        handleUpdateValue={handleUpdateValue}
                        name={name}
                    />
                )

            case fieldtype.url:
                const urlImg = defaultValue && typeof defaultValue === 'string' ?
                    urlPatterns.filter(item => item.subs.some(sub => defaultValue.indexOf(sub) !== -1)) : {}

                return (
                    <React.Fragment>
                        <Url href={defaultValue} target='_blank'>
                            <Icon icon={urlImg.length ? urlImg[0].name : 'globe'} width={27} height={27}/>
                        </Url>
                        <TextField
                            defaultValue={defaultValue}
                            handleBlur={handleUpdateValue}
                            readonly={uneditable}
                            lookup={lookup}
                            name={name}
                            environment={environment}
                            row={row}
                        />
                    </React.Fragment>
                )

            case fieldtype.phone:
                return (
					<Phone
						config={settings}
						defaultValue={defaultValue}
						readonly={uneditable}
						lookup={lookup}
						name={name}
						environment={environment}
						row={row}
						handleUpdate={handleUpdateValue}
					/>
                )

            case fieldtype.linkedfield:
                return (
                    <LinkedField
                        defaultValue={defaultValue}
                        handleUpdateValue={handleUpdateValue}
                        foreignerEcn={foreignerEcn}
                        linkedRelation={linkedRelation ? linkedRelation[0] : null}
                        name={name}
                        row={row}
                        title={title}
                        readonly={uneditable}
                        disableCreate={disableCreate}
                        environment={environment}
                    />
                )

            case fieldtype.check:
                return (
                    <Toggle
                        defaultValue={defaultValue}
                        handleUpdateValue={handleUpdateValue}
                        name={name}
                        readonly={uneditable}
                    />
                )

            case fieldtype.textarea:
                return (
                    <Textarea
                        defaultValue={defaultValue}
                        handleUpdateValue={handleUpdateValue}
                        name={name}
                        readonly={uneditable}
                        lookup={lookup}
                        environment={environment}
                        row={row}
                    />
                )

            case fieldtype.formula: {
                    return (
                        <Formula
                            defaultValue={defaultValue}
                            name={name}
                        />
                    )
            }

            case fieldtype.lookup:
                return (
                    <Base lookup={true}>
                        {defaultValue}
                    </Base>
                )

            default:
                return (
                    <TextField
                        defaultValue={defaultValue}
                        handleBlur={handleUpdateValue}
                        name={name}
                        readonly={uneditable}
                        lookup={lookup}
                        environment={environment}
                        row={row}
                    />
                )
        }
    }

    return (
        <React.Fragment>
            {type === fieldtype.lookup && lookupConfig ?
                getField(lookupType, lookupConfig, true, true) :
                getField(type, config, !permissions.Write || readonly, false)
            }
        </React.Fragment>
    )
}

export default injectIntl(CellValue)
